if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        this.productId = this.dataset.productId;
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');
        var fetchURL = opener.getAttribute('data-product-url');
        fetchURL = fetchURL + '?view=quick-add';
        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="QuickProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);
            const sectionId = this.productElement.dataset.section;
            const quickViewContainer = this.modalContent;           
            initQuickViewGallery(quickViewContainer, sectionId);
             // for BR events
            const quickViewItemHandle = opener.getAttribute('data-product-handle');
            const catEl = this.productElement;            
            const var_color = catEl.getAttribute('data-meta-color') || '';
            const cateData = {
              category_level_1: catEl.getAttribute('data-cat-level-1') || '',
              category_level_2: catEl.getAttribute('data-cat-level-2') || '',
              category_level_3: catEl.getAttribute('data-cat-level-3') || '',
              categories_path: catEl.getAttribute('data-cat-path') || '',
              category_id: catEl.getAttribute('data-cat-id') || '',
              categories_ids: JSON.parse(catEl.getAttribute('data-cat-ids') || '[]')
            };          
            const isBloomreachAvailable = opener.getAttribute('data-BR-avail') === 'true';
            setTimeout(() => {
              const funcName1 = `func_bloomreach_product_json_${this.productId}`;              
              const quickProductForm = this.modalContent.querySelector(`form[data-id="product-form-${this.productId}"]`);     
              if (quickProductForm) {                
                if (isBloomreachAvailable) {
                 injectBloomreachData(null, quickViewItemHandle, quickProductForm, this.productId, null, var_color, cateData);
                }                
                else {
                  if (typeof window[funcName1] === 'function' && quickProductForm) {
                    window[funcName1](600);                
                  }
                }
               }
            }, 50);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
function initQuickViewGallery(container, sectionId, idAppend = '') {
  if (!container) return;
 initScopedQuickviewSwiper(container);
}

function initScopedQuickviewSwiper(container) {
  const swiperEl = container.querySelector('.quickview-swiper');
  if (!swiperEl) return;

  // Destroy if already present in this container
  if (container.quickviewSwiper) {
    container.quickviewSwiper.destroy(true, true);
  }

  // Create Swiper instance scoped to this quick view
  container.quickviewSwiper = new Swiper(swiperEl, {
    slidesPerView: 'auto',
    spaceBetween: 0,
    speed: 500,
    navigation: {
      nextEl: container.querySelector('.quickview-swiper-next'),
      prevEl: container.querySelector('.quickview-swiper-prev'),
    },
    loop: false,
    watchSlidesVisibility: true,
    observer: true,
    observeParents: true,
  });

  // Function to update Swiper to first visible slide dynamically
  function showFirstVisibleSwiperImage() {
    const slides = Array.from(container.querySelectorAll('.quickview-swiper .swiper-slide'));

    // Remove previous hidden markers
    slides.forEach(slide => slide.classList.remove('swiper-slide-hidden'));

    // Mark hidden ones
    slides.forEach(slide => {
      if (slide.style.display === 'none' || slide.classList.contains('hidden')) {
        slide.classList.add('swiper-slide-hidden');
      }
    });

    // Find first visible slide index
    const firstVisibleIndex = slides.findIndex(slide => !slide.classList.contains('swiper-slide-hidden'));

    if (firstVisibleIndex >= 0) {
      container.quickviewSwiper.slideTo(firstVisibleIndex);
    }
  }
  
  container.querySelectorAll('.var-gridbox input, .var-gridbox button').forEach(input => {
    input.addEventListener('change', function() {
      const sizeLegend = container.querySelector('#sizeLegend');
      if (sizeLegend && this.dataset.value) {
        sizeLegend.querySelector('span').innerText = this.dataset.value;
      }
      showFirstVisibleSwiperImage();
    });
  });
}